/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-22 13:51:37
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-19 17:35:07
 * @FilePath: /lobby/src/stores/user.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { AIRBRIDEG_EVENT, airbrideg_report } from '@/common/airbridge'
import { config, defaultCountry, url } from '@/common/config.js'
import { getLocalStorage, Key, removeLocalStorage, setLocalStorage } from '@/common/localStorage.js'
import { post } from '@/common/request.js'
import { BUS, POPUP } from '@/event/EventCenter'
import SocketService from '@/server/socket'
import { chunkArray } from '@/utils/helper'
import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import { GAME_NAV_TAB_TYPE, useLobbyStore } from './lobby'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      countries: {
        // BR: { icon: `${config.resBaseUrl}flag_brazi.jpg`, phone: 55, name: 'Brazi', code: 'BR' },
        ET: {
          icon: `${config.resBaseUrl}flag_ethiopia.jpg`,
          phone: 251,
          name: 'Ethiopia',
          code: 'ET'
        },
        KE: {
          icon: `${config.resBaseUrl}flag_kenya.jpg`,
          phone: 254,
          name: 'Kenya',
          code: 'KE'
        },
        CI: {
          icon: `${config.resBaseUrl}flag_IvoryCoast.jpg`,
          phone: 225,
          name: 'IvoryCoast',
          code: 'CI'
        },
        TZ: {
          icon: `${config.resBaseUrl}flag_TZ.png`,
          phone: 255,
          name: 'Ethiopia',
          code: 'TZ'
        },
        GH: {
          icon: `${config.resBaseUrl}flag_Ghana.png`,
          phone: 233,
          name: 'Ethiopia',
          code: 'GH'
        }
        // NG: {
        //   icon: `${config.resBaseUrl}flag_Nigeria.jpg`,
        //   phone: 234,
        //   name: 'Nigeria',
        //   code: 'NG'
        // }
      },
      country: defaultCountry(),
      token: getLocalStorage(Key.Token),
      balance: {},
      userInfo: {},
      methodConfig: [],
      rechargeCount: 0,
      cid: false
    }
  },
  getters: {
    isLogin() {
      return this.token.length > 0
    }
  },
  actions: {
    initCountry(country) {
      this.country = country.toUpperCase()
    },
    register(country, username, password, verificationCode, envelopeId, inviteUserId, agentcode) {
      return post(url.user.register, {
        country: country,
        username: String(username).replace(/\s+/g, ''), // 先转换为字符串再去除空格
        password: password,
        verificationCode,
        envelopeId,
        inviteUserId,
        cid: localStorage.getItem(Key.cid),
        channel: localStorage.getItem(Key.channel),
        agentcode: agentcode
      }).then((response) => {
        if (response.status) {
          this.updateUserInfo()
        }
        return response
      })
    },
    logout() {
      return post(url.user.logout, {})
        .then((r) => {
          console.log(`logout:`, r)
          this.setToken()
          this.balance = {}
          this.userInfo = {}
          this.country = defaultCountry()
          SocketService.disconnect()
        })
        .then((res) => {
          console.log(res)
          airbrideg_report(AIRBRIDEG_EVENT.SIGNOUT)
        })
    },
    login(country, username, password) {
      return post(url.user.login, {
        country: country,
        username: String(username).replace(/\s+/g, ''), // 先转换为字符串再去除空格
        password: password
      }).then((r) => {
        if (r.status === 1) {
          this.updateUserInfo()
          window.bridge.$emit(BUS.SHOW_POPUP, {
            from: 'homeview',
            to: POPUP.LOGIN,
            show: false
          })
        }
        return r
      })
    },
    setToken(token = '') {
      if (this.token != token) {
        window.localStorage.clear()
        // removeLocalStorage(Key.shared)
        // removeLocalStorage(Key.currentReward)
        // removeLocalStorage(Key.clickShareIcon)
        // removeLocalStorage(Key.clickInviteBtn)
        // removeLocalStorage(Key.firstdepositpopup)
        // removeLocalStorage(Key.PerksPlay)
        // removeLocalStorage(Key.todayShowed)
        // removeLocalStorage(Key.Locale)
      }
      this.token = token
      if (token.length === 0) {
        removeLocalStorage(Key.Token)
      } else {
        setLocalStorage(Key.Token, token)
      }
    },
    updateUserInfo() {
      return new Promise((resolve) => {
        if (!this.isLogin) {
          console.log('updateUserInfo: not login')
          resolve()
        } else {
          post(url.user.balance).then((r) => {
            this.balance = r
            console.log(`balance:`, this.balance)
          })
          post(url.user.getUserInfo).then((r) => {
            this.userInfo = r
            this.country = r.country
            this.cid = true // r.cid === 'inw'
            if(r.cid == 'inw'){
              useLobbyStore().navtabType = GAME_NAV_TAB_TYPE
            }
            this.usc()
            console.log(`getUserInfo:`, this.userInfo)
            console.log('cid=============>', this.cid)
            resolve()
          })
        }
      })
    },
    sms(country, phoneNumber) {
      return post(url.user.sms, {
        country,
        phoneNumber
      })
    },
    usernameSms(country, username) {
      return post(url.user.usernameSms, {
        country,
        username
      })
    },
    bindPhone(username, verificationCode) {
      return post(url.user.bindPhone, { username, verificationCode })
    },
    restPwd(country, password, username, verificationCode) {
      return post(url.user.restPwd, {
        country,
        password,
        username,
        verificationCode
      })
    },
    updateCountry(country) {
      if (this.country == country) {
        return
      }
      this.country = country
      // setLocalStorage(Key.Country, country)
    },
    checkBindViaUser(country, username) {
      return post(url.user.checkBindViaUser, {
        country,
        username
      })
    },
    changePassWord(oldPassword, password) {
      return post(url.user.changePassWord, {
        oldPassword,
        password
      })
    },
    /**
     * 获取充值方式配置
     */
    paymentMethods() {
      return post(url.recharge.paymentMethods).then((res) => {
        this.methodConfig = chunkArray(res.configs, 3, true)
        console.log('methodConfig', this.methodConfig)
        return res
      })
    },
    withdrawPayMentMethods() {
      return post(url.withdraw.paymentMethods).then((res) => {
        this.methodConfig = chunkArray(res.configs, 3, true)
        console.log('methodConfig', this.methodConfig)
        return res
      })
    },
    usc() {
      return post(url.user.usc).then((r) => {
        this.rechargeCount = r.count
        if (
          this.country != 'GH' &&
          r.count == 0 &&
          getLocalStorage(Key.firstdepositpopup) != dayjs().format('YYYY-MM-DD')
        ) {
          setLocalStorage(Key.firstdepositpopup, dayjs().format('YYYY-MM-DD'))
          window.bridge.$emit(BUS.SHOW_POPUP, {
            from: 'homeview',
            to: POPUP.FIRST_DEPOSIT_POPUP,
            show: true
          })
        } else if (
          this.country != 'GH' &&
          this.country != 'ET' &&
          r.count > 0 &&
          getLocalStorage(Key.PerksPlay) != dayjs().format('YYYY-MM-DD')
        ) {
          setLocalStorage(Key.PerksPlay, dayjs().format('YYYY-MM-DD'))
          window.bridge.$emit(BUS.SHOW_POPUP, {
            from: 'homeview',
            to: POPUP.PERKS_PLAY_POPUP,
            show: true
          })
        }
        return r
      })
    }
  }
})
